import { render, staticRenderFns } from "./c_tab.vue?vue&type=template&id=bec2917a&scoped=true"
import script from "./c_tab.vue?vue&type=script&lang=js"
export * from "./c_tab.vue?vue&type=script&lang=js"
import style0 from "./c_tab.vue?vue&type=style&index=0&id=bec2917a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec2917a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec2917a')) {
      api.createRecord('bec2917a', component.options)
    } else {
      api.reload('bec2917a', component.options)
    }
    module.hot.accept("./c_tab.vue?vue&type=template&id=bec2917a&scoped=true", function () {
      api.rerender('bec2917a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_tab.vue"
export default component.exports